import LinkButton from "./component-library3.mjs";
import "./component-library184.mjs";
import normalizeComponent from "./component-library82.mjs";
const _sfc_main = {
  name: "ToggleButton",
  components: { LinkButton },
  props: {
    toggleLabelLeft: { type: String, default: "Klein" },
    toggleLabelRight: { type: String, default: "Groß" }
  },
  emits: ["update:toggle"],
  data() {
    return {
      isActive: false
    };
  },
  methods: {
    clicked() {
      this.isActive = !this.isActive;
      this.$emit("update:toggle", this.isActive);
    }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("div", { staticClass: "toggle-button" }, [_c("LinkButton", { staticClass: "toggle-button__cta", attrs: { "tag": "button", "no-styling": "", "type": "button" }, on: { "click": _vm.clicked } }, [_c("span", { staticClass: "toggle-button__pointer", class: { "toggle-button__pointer--active": _vm.isActive } }), _c("span", { staticClass: "toggle-button__label", class: { "toggle-button__label--active": !_vm.isActive } }, [_vm._v(" " + _vm._s(_vm.toggleLabelLeft) + " ")]), _c("span", { staticClass: "toggle-button__label", class: { "toggle-button__label--active": _vm.isActive } }, [_vm._v(" " + _vm._s(_vm.toggleLabelRight) + " ")])])], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "68f59d42",
  null,
  null
);
const ToggleButton = __component__.exports;
export {
  ToggleButton as default
};
